// extracted by mini-css-extract-plugin
export var Col = "Footer-module--Col--38a9b";
export var Cols = "Footer-module--Cols--e3615";
export var Copyright = "Footer-module--Copyright--a1676";
export var Title = "Footer-module--Title--65780";
export var Wrapper = "Footer-module--Wrapper--a2228";